<template>
  <div class="view view-preauth">
    <router-link :to="'/'" class="view-preauth__homelink">
      <svg
        class="view-preauth__logo"
        viewBox="0 0 309 52"
        height="100%"
        width="100%"
        @click="$emit('logo-click')"
      >
        <use href="#simcision-logo-slim" height="10" />
      </svg>
    </router-link>

    <locale-chooser class="view-preauth__localechooser" />

    <router-view></router-view>

    <footer class="view-preauth__footer">
      <router-link :to="{ name: 'imprint' }">{{
        $t("labels.imprint")
      }}</router-link>
    </footer>
  </div>
</template>

<script setup lang="ts">
import LocaleChooser from "@core/input/LocaleChooser.vue";
</script>

<style lang="scss">
.view-preauth {
  padding: 3rem;
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 1fr;
  grid-template-rows: minmax(0, 1fr) min-content;
  background-color: var(--color-background);
  background-size: 480px auto;
  background-image: url("/img/pattern.svg");
  gap: 1rem;

  &__homelink {
    position: absolute;
    top: 1rem;
    left: 1rem;
  }

  &__logo {
    width: 10rem;
    height: auto;
  }

  &__localechooser {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }

  &__footer {
    text-transform: uppercase;
    text-align: center;
  }
}
</style>
